<div class="m-6" >

  <div class="columns">
    <div class="column">
      <h4 class="title is-4 text-blue">Auftrag Eigentümerrecherche</h4>
    </div>
  </div>


  <div class="columns">
    <div class="column p-4 mt-3 ml-3 mr-3 card has-round-border" style="box-shadow: 0 4px 5px 2px rgba(0, 0, 0, 0.3);">
      <div class="columns mx-3">
        <div class="column">

          <h3 class="title is-6 pb-1 mb-1 text-blue ">Lieferumfang</h3>
          <p><strong> Grundsstückseigentümer </strong> bzw. <strong> zuständige Hausverwaltung</strong>.</p>
          <p>Geliefert wird Vor- und Nachname bzw. Name der juristischen Person, Anschrift und evtl. eine
            Telefonnummer.</p>
        </div>
      </div>

      <div class="columns mx-3">
        <div class="column">
          <div class="columns pb-0 mb-0">
            <div class="column pb-0 mb-0">
              <h3 class="title is-6 pb-1 mb-1 text-blue">Beschaffung der Daten</h3>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <form>
                <div class="columns pb-0 mb-0">
                  <div class="column pb-0 mb-0">
                    <label>
                      <input
                          class="custom-radio"
                          type="radio" name="procurementType"
                          [(ngModel)]="procurementType"
                          value="Standard"
                      />Standardlieferung (Die Daten stehen in 35 Tagen für Sie bereit)
                    </label>
                    <span class="text-blue ml-6"> {{platformProfile?.pricing?.additionalPositions?.['ownre'] }} €</span>
                  </div>
                </div>
                <div class="columns pt-0 mt-0">
                  <div class="column pt-0 mt-0">
                    <label>
                      <input
                          class="custom-radio"
                          type="radio"
                          name="procurementType"
                          [(ngModel)]="procurementType"
                          value="Express"
                      />Expresslieferung (Die Daten stehen in 14 Tagen für Sie bereit) &nbsp;&nbsp;
                    </label>
                    <span class="text-blue ml-6"> {{platformProfile?.pricing?.additionalPositions?.['ownrex'] }} €</span>
                  </div>

                </div>
              </form>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <p> Hinweis: Unsere Erfolgsquote liegt bei 80-90%. Sollten wir keine Ergebnisse durch unsere Recherche liefern können,
                werden Ihnen keine Kosten in Rechnung gestellt. Sie erhalten einen Negativvermerk. </p>
            </div>

          </div>
        </div>
      </div>


    </div>
  </div>


  <div class="columns">
    <div class="column m-3 card has-round-border" style="box-shadow: 0 4px 5px 2px rgba(0, 0, 0, 0.3);">
      <div class="columns m-3 ">
        <div class="column">
          <h3 class="title is-5 text-blue">Grundstücksdaten</h3>
        </div>
        </div>
      <div class="columns mx-3">
        <div class="column" *ngIf="property">
          <app-property-form
              [showCheckbox]="true"
              [isOwnerResearch]="true"
              [property]="property"
              [shouldHaveLandregisterValidators]="true"
          ></app-property-form>
        </div>
      </div>


      <div class="columns mx-3">
        <div class="column is-6">

          <form [formGroup]="otherHintForm">

            <div class="title is-5 has-text-left is-darkblue mb-1">
              <p class="hint"> Sonstige Hinweise bzw. Vermutungen zum Eigentümer
                <span *ngIf="otherHintForm && otherHintForm.value['additionalInfo']" class="additional-text-information"
                      [ngClass]="{'required':otherHintForm.value['additionalInfo'].length > maxInfoInput}">
                                   {{ otherHintForm.value['additionalInfo'].length + ' / ' + maxInfoInput + ' Zeichen' }}
                                </span>

              </p>
            </div>
            <div class="columns">
              <div class="column">
                <div class="text-area-container p-2 has-round-border is-flex is-justify-content-center is-align-items-center has-box-shadow mt-3 mb-3"
                     [ngClass]="{'has-error': hasError(otherHintForm.get('additionalInfo'))}">
                                  <textarea #additionalInfoTextarea formControlName="additionalInfo" cdkTextareaAutosize
                                            cdkAutosizeMinRows="1"
                                            cdkAutosizeMaxRows="7"
                                            placeholder="Hinweise" class="w-100 no-border"
                                  ></textarea>
                </div>
              </div>
            </div>
          </form>

        </div>
      </div>

      <hr>
      <div class="columns mx-3">
        <div class="column">
          <h3 class="title is-5 text-blue">Berechtigtes Interesse</h3>

          <form [formGroup]="anliegenForm" >
            <div>
              <label *ngFor="let interessenOption of interessenOptionen"
                     [ngClass]="{'has-error-text': (legitimateInterest === '' && (anliegenForm?.get('anliegenType').value !== 'Sonstiges' )) &&  anliegenForm?.get('anliegenType').touched}">
                <input class="custom-radio"
                       type="radio" formControlName="anliegenType" [value]="interessenOption.value"> {{ interessenOption.name }} <br>
              </label>
            </div>

            <div *ngIf="anliegenForm.get('anliegenType').value === 'Sonstiges'">
              <input  class="border-input" type="text" formControlName="sonstigesDetails" placeholder="Bitte erläutern" [ngClass]="{'has-error': !legitimateInterest && anliegenForm?.get('sonstigesDetails').touched }">
            </div>
          </form>

        </div>
      </div>
      <hr>
      <div class="columns mx-3">
        <div class="column">
          <h3 class="title is-5 text-blue">Datenschutz</h3>
          <form [formGroup]="dataPrivacyForm">
            <div class="data-privacy-checkbox-container">
              <input class="custom-checkbox custom-checkbox-privacy" type="checkbox" formControlName="dataPrivacy" />
              <label [ngClass]="{'has-error-text': dataPrivacyForm.controls['dataPrivacy'].touched && !dataPrivacyForm.controls['dataPrivacy'].value}">
                Durch das Absenden der Bestellung stimmen Sie unseren
                <a (click)="navigateTo($event, 'https://www.docestate.com/agb/')">AGBs</a> und
                <a (click)="navigateTo($event, 'https://www.docestate.com/datenschutzerklaerung/')">Datenschutzbestimmungen</a> zu.
                Darüber hinaus erklären Sie sich damit einverstanden, dass Ihre Kontaktdaten gemäß den Datenschutzbestimmungen des Art. 14 DSGVO an die recherchierte Partei weitergegeben werden.
              </label>
            </div>
          </form>
        </div>
      </div>

      <div class="columns m-3 is-12">
        <div class="column is-12">
          <div class="columns is-flex is-align-content-space-between is-justify-content-space-between">
            <div class="column is-4 button-custom-width">
              <a (click)="back()" class="button back-button is-size-6 has-round-border" style="border:none;display: block !important;">
                <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
                  <div class="column is-one-fifth">
                    <img alt="Arrow Left" src="assets/images/button/left_btn.svg">
                  </div>
                  <div class="column">
                    <p class="is-bold" style="padding-right: 2rem; padding-bottom: 10px;">Zurück</p>
                  </div>
                </div>
              </a>
            </div>
            <div class="column is-4 button-custom-width">
              <a (click)="orderSummery()" class="button buy-button is-size-6 has-round-border" style="border:none; display: block!important;">
                <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
                  <div class="column is-bold"><p style="padding-left: 2rem; padding-bottom: 10px">Bestellzusammenfassung</p></div>
                  <div class="column is-one-fifth">
                    <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
